// This functionality will display table
// after calculator / filter form submit
import $ from 'jquery';

import filterHelper from '../filters/helper';

const containerPlaceholder = '.js-comparison-calculator-container';
const targetTablePlaceholder = '.js-comparison-table-container';
const comparisonCalculatorSelector = '.js-comparison-calculator';
const comparisonTableSelector = '.js-calculator-table';
const comparisonTableLoading = '.js-comparison-table--loading';
const calculatorWidgetSelector = '.js-table-widget-calculator, .calculator-form';

function showPanel(panel, show = true) {
  if (show) {
    $(panel).removeClass('hide');
  } else {
    $(panel).addClass('hide');
  }
}

function updateCalculatorFormHandler($calcForm, $parent) {
  $calcForm.on('submit', (event) => {
    event.preventDefault();
    window.finder.calculators.submitData($parent);
  });
}

function updateCalcForm($tableContainer, calculatorValues) {
  const $parent = $tableContainer.find(comparisonCalculatorSelector);
  const $calcForm = $tableContainer.find(calculatorWidgetSelector);
  filterHelper.updateFormAboveTable($calcForm, calculatorValues);
  updateCalculatorFormHandler($calcForm, $parent);
  window.finder.calculators.submitData($parent);
}

/**
 * Option to redraw table (body_only or full_table)
 * @param form
 * @param category - table category (AJAX category parameter)
 * @param fieldset - table template (AJAX fieldset parameter)
 * @param calculatorValues - calculator field values
 */
function redrawTable(form, { category, fieldset, site }, calculatorValues) {
  const $tableContainer = $(targetTablePlaceholder);

  const params = {
    action: 'redraw_table_ajax',
    template: 'comparison',
    site,
    fieldset,
    category,
    full_table: true,
  };

  $.get(`${window.location.origin}/wordpress/wp-admin/admin-ajax.php`, params)
    .then((result) => {
      showPanel(comparisonTableLoading, false);
      showPanel(targetTablePlaceholder);
      const doWeHaveResult = result && result.html;
      if (doWeHaveResult) {
        $tableContainer.html(result.html);

        if (calculatorValues) {
          updateCalcForm($tableContainer, calculatorValues);
        }

        $(document).trigger('full-table-redraw', targetTablePlaceholder);
      } else {
        // TODO: Display container for no result
      }
    })
    .always(results =>
      $tableContainer.find(comparisonTableSelector).trigger('onLoaded', results),
    );
}

function slideViewToTable(shouldPageSlideToTable = false) {
  if (shouldPageSlideToTable) {
    $('html, body')
      .animate({ scrollTop: $(containerPlaceholder).offset().top }, 1000);
  }
}

function standAloneForm(selector) {
  const forms = document.querySelectorAll(selector);

  $(forms).on('submit', (event) => {
    event.preventDefault();
    showPanel(comparisonTableLoading);

    const { target } = event;
    const form = $(target);
    const calculatorValues = filterHelper.getFormFilters(form);

    slideViewToTable(form.hasClass('js-slide-to-table'));
    redrawTable(form, target.dataset, calculatorValues);
  });
}

export default standAloneForm;
